import AssetFinance from './AssetFinance';

export default AssetFinance;
